import { render, staticRenderFns } from "./ShortVideoFriendItem.vue?vue&type=template&id=4b109700&scoped=true"
import script from "./ShortVideoFriendItem.vue?vue&type=script&lang=js"
export * from "./ShortVideoFriendItem.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoFriendItem.vue?vue&type=style&index=0&id=4b109700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b109700",
  null
  
)

export default component.exports